import { Component } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import MapView from './mapView';
import * as RefData from './refData'

class ViewQR extends Component {
  state = {
    data: {
      ...this.props.qrData,
      diasLaborales: this.props.qrData.diasLaborales ? this.props.qrData.diasLaborales.split('').map(d => ({ id: parseInt(d) })) : []
    },
    editable: this.props.session.user.permitions.map(p => p.rol).includes('ADMIN')
  }

  gender = [
    { id: 1, name: 'Masculino' },
    { id: 2, name: 'Femenino' },
  ]

  siNo = [
    { id: 1, name: 'Si' },
    { id: 2, name: 'No' },
  ]

  timeUnit = [
    { id: 1, name: 'Años' },
    { id: 2, name: 'Meses' },
  ]

  civilState = [
    { id: 1, name: 'Soltero (a)' },
    { id: 2, name: 'Casado (a)' },
    { id: 3, name: 'Unión Marital de Hecho' },
    { id: 4, name: 'Separado (a)' },
    { id: 5, name: 'Viudo (a)' },
  ]

  schoolarship = [
    { id: 1, name: 'Analfabeta' },
    { id: 2, name: 'Primaria' },
    { id: 3, name: 'Secundaria' },
    { id: 4, name: 'Técnico' },
    { id: 5, name: 'Tecnólogo' },
    { id: 6, name: 'Superior' },
  ]

  daysOfWeek = [
    { id: 1, name: 'Lunes' },
    { id: 2, name: 'Martes' },
    { id: 3, name: 'Miércoles' },
    { id: 4, name: 'Jueves' },
    { id: 5, name: 'Viernes' },
    { id: 6, name: 'Sábado' },
    { id: 7, name: 'Domingo' },
  ]

  economicActivity = [
    { id: 3, name: 'Artesanias' },
    { id: 4, name: 'Cacharrería' },
    { id: 6, name: 'Cerrajería' },
    { id: 7, name: 'Ferretería' },
    { id: 25, name: 'Helados' },
    { id: 8, name: 'Juguetería' },
    { id: 9, name: 'Libros' },
    { id: 10, name: 'Lotería' },
    { id: 11, name: 'Relojería' },
    { id: 27, name: 'Reparación de Calzado' },
    { id: 12, name: 'Ropa' },
    { id: 13, name: 'Taller biciletas' },
    { id: 14, name: 'Taller electrodomésticos' },
    { id: 15, name: 'Utensilios de cocina' },
    { id: 16, name: 'Venta alimentos preparados' },
    { id: 17, name: 'Venta alimentos empacados' },
    { id: 26, name: 'Venta de Calzado' },
    { id: 18, name: 'Venta de música' },
    { id: 19, name: 'Plantas medicinales' },
    { id: 20, name: 'Cigarrillos y dulces' },
    { id: 22, name: 'Frutas, verduras' },
    { id: 23, name: 'Pescado, mariscos' },
    { id: 24, name: 'Jugos u otras bebidas sin licor' },
    { id: 21, name: 'Otros' },
  ]

  subActivitiesPreparados = [
    { id: 1, name: 'Fritos' },
    { id: 2, name: 'Sopas' },
    { id: 3, name: 'Arroces' },
    { id: 4, name: 'Comidas Rápidas' },
    { id: 5, name: 'Pasteles' },
  ];

  subActivitiesJugos = [
    { id: 6, name: 'Gaseosas' },
    { id: 7, name: 'Jugos Naturales' },
    { id: 8, name: 'Limonada / Naranjada' },
    { id: 9, name: 'Agua de Coco' },
  ];

  hasAccounting = [
    { id: 1, name: 'Si' },
    { id: 2, name: 'No' },
    { id: 3, name: 'Cuaderno' },
  ]

  occupationReason = [
    { id: 1, name: 'Desempleo' },
    { id: 2, name: 'Oportunidad' },
    { id: 3, name: 'Necesidad' },
    { id: 4, name: 'Otra' },
  ]

  affiliationType = [
    { id: 1, name: 'Sisben' },
    { id: 2, name: 'EPS' },
  ]

  sisbenGroup = [
    { id: 1, name: 'A' },
    { id: 2, name: 'B' },
    { id: 3, name: 'C' },
    { id: 4, name: 'D' },
  ]

  houseKind = [
    { id: 1, name: 'Propia' },
    { id: 2, name: 'De parientes' },
    { id: 3, name: 'Arriendo' },
    { id: 4, name: 'Pago por cuotas' },
    { id: 5, name: 'Invasión sin documentos' },
    { id: 6, name: 'Invasión con documentos' },
    { id: 7, name: 'Prestada' },
  ]

  countries = [
    { id: 40, name: 'COLOMBIA' },
    { id: 189, name: 'VENEZUELA' },
    { id: 1, name: 'AFGANISTÁN' },
    { id: 2, name: 'ALBANIA' },
    { id: 3, name: 'ALEMANIA' },
    { id: 4, name: 'ANDORRA' },
    { id: 5, name: 'ANGOLA' },
    { id: 6, name: 'ANTIGUA Y BARBUDA' },
    { id: 7, name: 'ARABIA SAUDITA' },
    { id: 8, name: 'ARGELIA' },
    { id: 9, name: 'ARGENTINA' },
    { id: 10, name: 'ARMENIA' },
    { id: 11, name: 'AUSTRALIA' },
    { id: 12, name: 'AUSTRIA' },
    { id: 13, name: 'AZERBAIYÁN' },
    { id: 14, name: 'BAHAMAS' },
    { id: 15, name: 'BANGLADÉS' },
    { id: 16, name: 'BARBADOS' },
    { id: 17, name: 'BARÉIN' },
    { id: 18, name: 'BÉLGICA' },
    { id: 19, name: 'BELICE' },
    { id: 20, name: 'BENIN' },
    { id: 21, name: 'BIELORRUSIA' },
    { id: 22, name: 'BOLIVIA' },
    { id: 23, name: 'BOSNIA Y HERZEGOVINA' },
    { id: 24, name: 'BOTSUANA' },
    { id: 25, name: 'BRASIL' },
    { id: 26, name: 'BRUNEI' },
    { id: 27, name: 'BULGARIA' },
    { id: 28, name: 'BURKINA FASO' },
    { id: 29, name: 'BURUNDI' },
    { id: 30, name: 'BUTÁN' },
    { id: 31, name: 'CABO VERDE' },
    { id: 32, name: 'CAMBOYA' },
    { id: 33, name: 'CAMERÚN' },
    { id: 34, name: 'CANADÁ' },
    { id: 35, name: 'CATAR' },
    { id: 36, name: 'CHAD' },
    { id: 37, name: 'CHILE' },
    { id: 38, name: 'CHINA' },
    { id: 39, name: 'CHIPRE' },
    { id: 41, name: 'COMORAS' },
    { id: 42, name: 'COREA DEL NORTE' },
    { id: 43, name: 'COREA DEL SUR' },
    { id: 44, name: 'COSTA DE MARFIL' },
    { id: 45, name: 'COSTA RICA' },
    { id: 46, name: 'CROACIA' },
    { id: 47, name: 'CUBA' },
    { id: 48, name: 'DINAMARCA' },
    { id: 49, name: 'DOMINICA' },
    { id: 50, name: 'ECUADOR' },
    { id: 51, name: 'EGIPTO' },
    { id: 52, name: 'EL SALVADOR' },
    { id: 53, name: 'EMIRATOS ARABES UNIDOS' },
    { id: 54, name: 'ERITREA' },
    { id: 55, name: 'ESLOVAQUIA' },
    { id: 56, name: 'ESLOVENIA' },
    { id: 57, name: 'ESPAÑA' },
    { id: 58, name: 'ESTADOS UNIDOS' },
    { id: 59, name: 'ESTONIA' },
    { id: 60, name: 'ETIOPÍA' },
    { id: 61, name: 'FILIPINAS' },
    { id: 62, name: 'FINLANDIA' },
    { id: 63, name: 'FIYI' },
    { id: 64, name: 'FRANCIA' },
    { id: 65, name: 'GABÓN' },
    { id: 66, name: 'GAMBIA' },
    { id: 67, name: 'GEORGIA' },
    { id: 68, name: 'GHANA' },
    { id: 69, name: 'GRANADA' },
    { id: 70, name: 'GRECIA' },
    { id: 71, name: 'GUATEMALA' },
    { id: 72, name: 'GUINEA' },
    { id: 73, name: 'GUINEA ECUATORIAL' },
    { id: 74, name: 'GUINEA-BISSAU' },
    { id: 75, name: 'GUYANA' },
    { id: 76, name: 'HAITÍ' },
    { id: 77, name: 'HONDURAS' },
    { id: 78, name: 'HUNGRÍA' },
    { id: 79, name: 'INDIA' },
    { id: 80, name: 'INDONESIA' },
    { id: 81, name: 'IRÁN' },
    { id: 82, name: 'IRAQ' },
    { id: 83, name: 'IRLANDA' },
    { id: 84, name: 'ISLANDIA' },
    { id: 85, name: 'ISLAS MARSHALL' },
    { id: 86, name: 'ISLAS SALOMÓN' },
    { id: 87, name: 'ISRAEL' },
    { id: 88, name: 'ITALIA' },
    { id: 89, name: 'JAMAICA' },
    { id: 90, name: 'JAPÓN' },
    { id: 91, name: 'JORDANIA' },
    { id: 92, name: 'KAZAJISTÁN' },
    { id: 93, name: 'KENIA' },
    { id: 94, name: 'KIRGUISTÁN' },
    { id: 95, name: 'KIRIBATI' },
    { id: 96, name: 'KUWAIT' },
    { id: 97, name: 'LAOS' },
    { id: 98, name: 'LESOTO' },
    { id: 99, name: 'LETONIA' },
    { id: 100, name: 'LÍBANO' },
    { id: 101, name: 'LIBERIA' },
    { id: 102, name: 'LIBIA' },
    { id: 103, name: 'LIECHTENSTEIN' },
    { id: 104, name: 'LITUANIA' },
    { id: 105, name: 'LUXEMBURGO' },
    { id: 106, name: 'MADAGASCAR' },
    { id: 107, name: 'MALASIA' },
    { id: 108, name: 'MALAUI' },
    { id: 109, name: 'MALDIVAS' },
    { id: 110, name: 'MALI' },
    { id: 111, name: 'MALTA' },
    { id: 112, name: 'MARRUECOS' },
    { id: 113, name: 'MAURICIO' },
    { id: 114, name: 'MAURITANIA' },
    { id: 115, name: 'MÉXICO' },
    { id: 116, name: 'MICRONESIA' },
    { id: 117, name: 'MOLDAVIA' },
    { id: 118, name: 'MÓNACO' },
    { id: 119, name: 'MONGOLIA' },
    { id: 120, name: 'MONTENEGRO' },
    { id: 121, name: 'MOZAMBIQUE' },
    { id: 122, name: 'MYANMAR (BIRMANIA)' },
    { id: 123, name: 'NAMIBIA' },
    { id: 124, name: 'NAURU' },
    { id: 125, name: 'NEPAL' },
    { id: 126, name: 'NICARAGUA' },
    { id: 127, name: 'NÍGER' },
    { id: 128, name: 'NIGERIA' },
    { id: 129, name: 'NORUEGA' },
    { id: 130, name: 'NUEVA ZELANDA' },
    { id: 131, name: 'OMÁN' },
    { id: 132, name: 'PAÍSES BAJOS' },
    { id: 133, name: 'PAKISTÁN' },
    { id: 134, name: 'PALAOS' },
    { id: 135, name: 'PALESTINA' },
    { id: 136, name: 'PANAMÁ' },
    { id: 137, name: 'PAPÚA NUEVA GUINEA' },
    { id: 138, name: 'PARAGUAY' },
    { id: 139, name: 'PERÚ' },
    { id: 140, name: 'POLONIA' },
    { id: 141, name: 'PORTUGAL' },
    { id: 142, name: 'PUERTO RICO' },
    { id: 143, name: 'REINO UNIDO' },
    { id: 144, name: 'REPÚBLICA CENTROAFRICANA' },
    { id: 145, name: 'REPÚBLICA CHECA' },
    { id: 146, name: 'REPÚBLICA DE MACEDONIA' },
    { id: 147, name: 'REPÚBLICA DEL CONGO' },
    { id: 148, name: 'REPÚBLICA DEMOCRÁTICA DEL CONGO' },
    { id: 149, name: 'REPÚBLICA DOMINICANA' },
    { id: 150, name: 'RUANDA' },
    { id: 151, name: 'RUMANIA' },
    { id: 152, name: 'RUSIA' },
    { id: 153, name: 'SAMOA' },
    { id: 154, name: 'SAN CRISTÓBAL Y NIEVES' },
    { id: 155, name: 'SAN MARINO' },
    { id: 156, name: 'SAN VICENTE Y LAS GRANADINAS' },
    { id: 157, name: 'SANTA LUCÍA' },
    { id: 158, name: 'SANTO TOMÉ Y PRÍNCIPE' },
    { id: 159, name: 'SENEGAL' },
    { id: 160, name: 'SERBIA' },
    { id: 161, name: 'SEYCHELLES' },
    { id: 162, name: 'SIERRA LEONA' },
    { id: 163, name: 'SIRIA' },
    { id: 164, name: 'SOMALIA' },
    { id: 165, name: 'SRI LANKA' },
    { id: 166, name: 'SUAZILANDIA' },
    { id: 167, name: 'SUDÁFRICA' },
    { id: 168, name: 'SUDÁN' },
    { id: 169, name: 'SUDÁN DEL SUR' },
    { id: 170, name: 'SUECIA' },
    { id: 171, name: 'SUIZA' },
    { id: 172, name: 'SURINAM' },
    { id: 173, name: 'TAILANDIA' },
    { id: 174, name: 'TANZANIA' },
    { id: 175, name: 'TAYIKISTÁN' },
    { id: 176, name: 'TIMOR ORIENTAL' },
    { id: 177, name: 'TOGO' },
    { id: 178, name: 'TONGA' },
    { id: 179, name: 'TRINIDAD Y TOBAGO' },
    { id: 180, name: 'TÚNEZ' },
    { id: 181, name: 'TURKMENISTÁN' },
    { id: 182, name: 'TURQUÍA' },
    { id: 183, name: 'TUVALU' },
    { id: 184, name: 'UCRANIA' },
    { id: 185, name: 'UGANDA' },
    { id: 186, name: 'URUGUAY' },
    { id: 187, name: 'UZBEKISTÁN' },
    { id: 188, name: 'VANUATU' },
    { id: 190, name: 'VIETNAM' },
    { id: 191, name: 'YEMEN' },
    { id: 192, name: 'YIBUTI' },
    { id: 193, name: 'ZAMBIA' },
    { id: 194, name: 'ZIMBABUE' },
  ]

  stationary = [
    { id: 1, name: 'Estacionaria' },
    { id: 2, name: 'Ambulante' },
  ]

  sisbenSubroup = (group) => {
    let end = 0
    switch (group) {
      case '1': end = 5; break;
      case '2': end = 7; break;
      case '3': end = 18; break;
      case '4': end = 21; break;
      default: break;
    }
    let resp = []
    for (let i = 1; i <= end; i++) resp.push({ id: i, name: i.toString() })
    return resp
  }

  getJobDays = (days) => {
    let resp = '';
    if (days.includes('1')) resp = 'Lunes';
    if (days.includes('2')) resp = resp + ', Martes';
    if (days.includes('3')) resp = resp + ', Miércoles';
    if (days.includes('4')) resp = resp + ', Jueves';
    if (days.includes('5')) resp = resp + ', Viernes';
    if (days.includes('6')) resp = resp + ', Sábado';
    if (days.includes('7')) resp = resp + ', Domingo';
    return resp.startsWith(', ') ? resp.substring(2) : resp;
  }

  updateData(key, value) {
    if (!this.state.editable) return
    if (key === 'refActividadProductivaId') {
      this.setState({
        data: {
          ...this.state.data,
          refSubActivityId: null,
          [key]: value
        }
      })
      return
    }
    this.setState({
      data: {
        ...this.state.data,
        [key]: value
      }
    })
  }

  textInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <input
            type={props.type ?? 'text'}
            value={data[props.key]}
            disabled={!this.state.editable || (props.disabled ?? false)}
            onChange={(e) => this.updateData(props.key, e.target.value)}
          />
        </div>
      </div>
    )
  }

  selectInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <select defaultValue={0} value={data[props.key]} disabled={!this.state.editable} onChange={(e) => this.updateData(props.key, e.target.value)} >
            <option value={0} disabled={true}>--</option>
            {
              props.keyRef.map(r => <option value={r.id} key={r.id}>{r.name}</option>)
            }
          </select>
        </div>
      </div>
    )
  }

  switchInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label >{props.label}</label>
        <div className='flex-center'>
          {
            data[props.key] ?
              <span onClick={() => this.updateData(props.key, false)} className='far fa-check-square primary-color' style={{ fontSize: '27px' }}></span>
              : <span onClick={() => this.updateData(props.key, true)} className='far fa-square' style={{ fontSize: '27px', color: 'rgba(0,0,0,0.6' }}></span>
          }
        </div>
      </div>
    )
  }

  checkInput(props) {
    const data = this.state.data
    return (
      <div className='line line-100'>
        <label >{props.label}</label>
        <div className=''>
          {
            this[props.keyRef].map(k =>
              <div className='line line-33' style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-evenly' }} key={k.id}>
                <label >
                  {k.name}
                </label>
                {
                  data[props.key].map(a => a.id).includes(k.id) ?
                    <span onClick={() => this.updateData(props.key, data[props.key].filter(f => f.id !== k.id))} className='far fa-check-square primary-color' style={{ fontSize: '27px' }}></span>
                    : <span onClick={() => this.updateData(props.key, [...data[props.key], { id: k.id }])} className='far fa-square' style={{ fontSize: '27px', color: 'rgba(0,0,0,0.6' }}></span>
                }
              </div>
            )
          }
        </div>
      </div >
    )
  }

  setTDR(tdr) {
    if (tdr < 10) return `TDR-0000${tdr}`;
    if (tdr < 100) return `TDR-000${tdr}`;
    if (tdr < 1000) return `TDR-00${tdr}`;
    if (tdr < 10000) return `TDR-0${tdr}`;
    return `TDR-${tdr}`;
  }
  render() {
    const { qrData, ...data } = this.props
    return (
      <>
        <div style={{ minHeight: '205px' }}>
          <div className='modal-title-header'>
            <div className='title-modal-kml-input no-select'>Espacio Público</div>
            <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={data.close}></i></div>
          </div>
          <div className="points-content data-qr">
            <div className='request-image-list div-input-form' style={{ maxWidth: '870px' }}>
              {
                qrData.citizenFiles.map(i =>
                  <img key={`i-${i.id}`} src={i.url} alt={i.name} />
                )
              }
            </div>
            <p><span>QR: </span>{qrData.qr}</p>
            {qrData.iep && <p><span>Encuestador: </span>{qrData.iep}</p>}
            {qrData.trd && <p><span>TRD: </span>{this.setTDR(qrData.trd)}</p>}
            {qrData.now && <p><span>Fecha: </span>{qrData.now.split('T')[0]}</p>}
            {
              qrData.documentFile &&
              <p>
                <a href={qrData.documentFile} alt="Descargar documento" title="Descargar Documento" target='_blank' rel="noreferrer" >Descargar Documento</a>
              </p>
            }
            <div className="content-line">
              {this.textInput({ key: 'nombre', label: 'Nombre' })}
              {this.textInput({ key: 'primerApellido', label: 'Primer Apellido' })}
              {this.textInput({ key: 'segundoApellido', label: 'Segundo Apellido' })}
              {this.textInput({ key: 'documento', label: 'Documento' })}
              {this.selectInput({ key: 'refGeneroId', label: 'Género', keyRef: this.gender })}
              {this.textInput({ key: 'edad', label: 'Edad', type: 'number' })}
              {this.textInput({ key: 'phone', label: 'Teléfono' })}
              {this.textInput({ key: 'mail', label: 'Correo electrónico' })}
              {this.selectInput({ key: 'refCountryId', label: 'Nacionalidad', keyRef: this.countries })}
            </div>
            <h2 className='primary-color'>Perfil</h2>
            <div className="content-line">
              {this.selectInput({ key: 'refEstadoCivilId', label: 'Estado Civil', keyRef: this.civilState })}
              {this.switchInput({ key: 'isOwner', label: '¿Paga al distrito?' })}
              {this.switchInput({ key: 'isPayToDistrit', label: '¿Es el propietario del negocio?' })}
              {this.switchInput({ key: 'isHeadFamily', label: '¿Es cabeza de hogar?' })}
              {this.selectInput({ key: 'refEscolaridadId', label: 'Escolaridad', keyRef: this.schoolarship })}
              {this.selectInput({ key: 'refPoblacionEspecialId', label: '¿Pertenece a alguna población especial?', keyRef: this.siNo })}
              {
                this.state.data.refPoblacionEspecialId === '1' &&
                this.textInput({ key: 'poblacionEspecial', label: '¿Cuál población' })
              }
              {this.selectInput({ key: 'refDiscapacidadId', label: '¿Tienen alguna discapacidad?', keyRef: this.siNo })}
              {
                this.state.data.refDiscapacidadId === '1' &&
                this.textInput({ key: 'discapacidad', label: '¿Cuál discapacidad' })
              }
              {this.selectInput({ key: 'refAsociacionId', label: '¿Pertenece a alguna asociación?', keyRef: this.siNo })}
              {
                this.state.data.refAsociacionId === '1' &&
                this.textInput({ key: 'asociacion', label: '¿Cuál asociación?' })
              }
            </div>
            <h2 className='primary-color'>Espacio Físico</h2>
            <div className="content-line">
              {this.selectInput({ key: 'refStationaryId', label: 'Venta estacionaria o ambulante', keyRef: this.stationary })}
              {this.selectInput({ key: 'refComunaId', label: 'Localidad', keyRef: RefData.comunas })}
              {this.selectInput({ key: 'refBarrioId', label: 'Barrio', keyRef: RefData.barrios.filter(f => f.refComunaId === parseInt(this.state.data.refComunaId)).sort((a, b) => a.name.localeCompare(b.name)) })}
              
              {this.textInput({ key: 'barrio', label: 'Barrio' })}
              {this.textInput({ key: 'direccion', label: 'Dirección' })}
              {this.textInput({ key: 'lat', label: 'Latitud', disabled: true })}
              {this.textInput({ key: 'lng', label: 'Longitud', disabled: true })}
              <MapView data={this.state.data} onChange={(key, val) => this.updateData(key, val)} />
              {this.textInput({ key: 'espacio', label: 'Espacio en m2', type: 'number' })}
              {this.textInput({ key: 'tiempo', label: 'Tiempo ocupando el epacio', type: 'number' })}
              {this.selectInput({ key: 'refUnidadTiempoId', label: 'Unidad de tiempo', keyRef: this.timeUnit })}
            </div>
            <h2 className='primary-color'>Actividad Productiva</h2>
            <div className="content-line">
              {this.checkInput({ key: 'diasLaborales', label: 'Días que labora', keyRef: 'daysOfWeek' })}
              {this.textInput({ key: 'openAt', label: 'Hora inicio actividades', type: 'time' })}
              {this.textInput({ key: 'closeAt', label: 'Hora fin actividades', type: 'time' })}
              {this.selectInput({ key: 'refActividadProductivaId', label: 'Actividad económica', keyRef: this.economicActivity })}
              {
                // eslint-disable-next-line eqeqeq
                this.state.data.refActividadProductivaId == '16' &&
                this.selectInput({ key: 'refSubActivityId', label: 'Tipo de Alimentos', keyRef: this.subActivitiesPreparados })
              }
              {
                // eslint-disable-next-line eqeqeq
                this.state.data.refActividadProductivaId == '24' &&
                this.selectInput({ key: 'refSubActivityId', label: 'Tipo de Bebidas', keyRef: this.subActivitiesJugos })
              }
              {this.textInput({ key: 'obsrvActividadProductiva', label: 'Observaciones actividad productiva' })}
              {this.selectInput({ key: 'refLlevaContavilidadId', label: 'Lleva contabilidad', keyRef: this.hasAccounting })}
              {this.textInput({ key: 'ventaDiaria', label: 'Valor aproximado de ventas diarias', type: 'number' })}
              {this.textInput({ key: 'ventaMensual', label: 'Valor aproximado de ventas mensuales', type: 'number' })}
              {this.selectInput({ key: 'refRazonOcupacionId', label: 'Razon de la ocupación en la actividad', keyRef: this.occupationReason })}
              {this.textInput({ key: 'horasDiarias', label: '¿Cuántas horas al dia didica?', type: 'number' })}
              {this.textInput({ key: 'numTrabajadoresCompleto', label: '# trabajadores familiares que trabajan con usted tiempo completo', type: 'number' })}
              {this.textInput({ key: 'numTrabajadoresMedio', label: '# trabajadores familiares que trabajan con usted medio tiempo', type: 'number' })}
              {this.textInput({ key: 'numTrabajadoresObra', label: '# trabajadores familiares que trabajan con usted por obra o labor', type: 'number' })}
              {this.selectInput({ key: 'refRecibenRemuneracionId', label: '¿Reciben remuneración?', keyRef: this.siNo })}
              {this.textInput({ key: 'numTrabajadoresContCompleto', label: '# trabajadores contratados tiempo completo', type: 'number' })}
              {this.textInput({ key: 'numTrabajadoresContMedio', label: '# trabajadores contratados medio tiempo', type: 'number' })}
              {this.textInput({ key: 'numTrabajadoresContObra', label: '# trabajadores contratados por obra o labor', type: 'number' })}
              {this.selectInput({ key: 'refEstanAfiliadosEpsId', label: '¿Estan afiliados a EPS?', keyRef: this.siNo })}
            </div>
            <h2 className='primary-color'>Seguridad social</h2>
            <div className="content-line">
              {this.selectInput({ key: 'refAfiliacionId', label: 'Tipo de afiliación en salud', keyRef: this.affiliationType })}
              {
                // eslint-disable-next-line eqeqeq
                this.state.data.refAfiliacionId == 1 &&
                <>
                  {this.selectInput({ key: 'refSisbenId', label: '¿Grupo SISBEN?', keyRef: this.sisbenGroup })}
                  {this.selectInput({ key: 'sisbenSub', label: '¿Subgrupo SISBEN?', keyRef: this.sisbenSubroup(this.state.data.refSisbenId) })}
                </>
              }
              {
                // eslint-disable-next-line eqeqeq
                this.state.data.refAfiliacionId == 2 &&
                this.textInput({ key: 'eps', label: 'EPS' })
              }
            </div>
            <h2 className='primary-color'>Vivienda</h2>
            <div className="content-line">
              {this.textInput({ key: 'barrVivienda', label: 'Barrio' })}
              {this.textInput({ key: 'dirVivienda', label: 'Dirección' })}
              {this.selectInput({ key: 'refTipoViviendaId', label: 'Tipo vivienda en la que habita', keyRef: this.houseKind })}
            </div>

            <div className='line line-100' style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div className="button-secondary line line-20 text-center">
                <div className="div-input-button">
                  <input type="button" value="Cerrar" onClick={data.close} />
                </div>
              </div>
              {
                this.props.session.user.permitions.map(p => p.rol).includes('ADMIN') &&
                <div className="button-primary line line-20 text-center">
                  <div className="div-input-button" style={{ backgroundColor: 'var(--primary-color)' }}>
                    <input
                      type="button" value="Guardar"
                      style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}
                      onClick={() => this.props.onSave(this.state.data)}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

export default connect(mapStateToProps)(ViewQR);